var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeWhiteClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "invisible-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.154,
    height: 15.902,
    viewBox: "0 0 29.154 15.902",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M4.549,16.921a2.624,2.624,0,0,0-2.26,1.3,1.739,1.739,0,0,0,.019,1.89,17.179,17.179,0,0,0,2.393,3L3,24.606a2.182,2.182,0,0,0-.44,2.956,5.136,5.136,0,0,0,.9.929,2.133,2.133,0,0,0,2.923-.46l1.9-2.2a16.9,16.9,0,0,0,2.4,1.124L9.77,29.667a2.182,2.182,0,0,0,1.1,2.78,5.134,5.134,0,0,0,1.245.354,2.133,2.133,0,0,0,2.3-1.86l.573-2.981q.8.078,1.608.078.617,0,1.233-.046l.567,2.949a2.134,2.134,0,0,0,2.3,1.86,5.132,5.132,0,0,0,1.245-.354,2.182,2.182,0,0,0,1.1-2.78l-.871-2.585a16.9,16.9,0,0,0,2.481-1.1l1.778,2.054a2.133,2.133,0,0,0,2.923.46,5.134,5.134,0,0,0,.9-.929,2.182,2.182,0,0,0-.44-2.956l-1.5-1.323a17.159,17.159,0,0,0,2.573-3.174,1.739,1.739,0,0,0,.019-1.89,2.624,2.624,0,0,0-2.26-1.3,1.543,1.543,0,0,0-1.209.7A13.083,13.083,0,0,1,16.6,23.04,13.083,13.083,0,0,1,5.757,17.625a1.543,1.543,0,0,0-1.209-.7Z",
    transform: "translate(-2.019 -16.92)",
    fill: "#fafaf4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeWhiteClosed);
export default __webpack_public_path__ + "static/media/eye-white-closed.addd40cafbeb6991453bc3a5ee7d57e8.svg";
export { ForwardRef as ReactComponent };